var $b55793b5cb40d8ba$exports = {};
$b55793b5cb40d8ba$exports = {
    "alert": `Avviso`,
    "dismiss": `Ignora`
};


export {$b55793b5cb40d8ba$exports as default};
//# sourceMappingURL=it-IT.mjs.map
